import { useTranslation } from "react-i18next";
import { WifiOff, RefreshCw } from "lucide-react";
import { useNetworkStatus } from "../hooks/useNetworkStatus";

export function NetworkBanner() {
  const { t } = useTranslation();
  const { isOnline, wasOffline, resetWasOffline } = useNetworkStatus();

  if (isOnline) {
    if (wasOffline) {
      return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 animate-in fade-in slide-in-from-bottom-4 duration-300">
          <div className="flex items-center gap-3 px-4 py-2.5 bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 font-mono text-xs uppercase tracking-wider">
            <WifiOff className="w-3.5 h-3.5 hidden" />
            <span>{t("network.back_online", { defaultValue: "Back online" })}</span>
            <button
              onClick={resetWasOffline}
              className="text-emerald-500 hover:text-emerald-300 underline underline-offset-2 ml-1"
            >
              {t("network.dismiss", { defaultValue: "Dismiss" })}
            </button>
          </div>
        </div>
      );
    }
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-black py-2 px-4 text-center font-mono text-xs uppercase tracking-wider">
      <div className="flex items-center justify-center gap-2">
        <WifiOff className="w-3.5 h-3.5" />
        <span>{t("network.offline", { defaultValue: "You are offline. Some features may not work." })}</span>
        <button
          onClick={() => window.location.reload()}
          className="inline-flex items-center gap-1 underline underline-offset-2 hover:text-zinc-700 ml-1"
        >
          <RefreshCw className="w-3 h-3" />
          {t("network.retry", { defaultValue: "Retry" })}
        </button>
      </div>
    </div>
  );
}

export default NetworkBanner;
